<template>
  <b-modal size="lg" ref="modal-quitacao" title="Quitação Registrada" @hidden="hiddenModal">
    <div class="row" v-show="telas == 0">
      <h5 class="card-label" style="margin-bottom: 20px; margin-left: 2px; width: 100%;">Selecione o portador:</h5>
      <b-list-group class="list-group-quitacao" v-show="portadores.length">
        <b-list-group-item 
          class="list-group-item-quitacao" 
          :class="{'list-group-item-quitacao-selecionado': (portador.ID_PORTADOR == idPortador)}" 
          v-for="portador in portadores" 
          :key="portador.ID_PORTADOR" 
          @click="selecionarPortador(portador.ID_PORTADOR)"
        >
          {{portador.NOME}}
        </b-list-group-item>
      </b-list-group>
      <img
        :src="
          fgModoPR == 'R'
            ? 'media/logos/Pulse-1s-200px.gif'
            : 'media/logos/Pulse-1s-200pxR.gif'
        "
        v-show="!portadores.length"
        style="margin: 0 auto;"
      />
    </div>
    <div class="row" v-show="telas == 1">
      <h5 class="card-label" style="margin-bottom: 20px; margin-left: 2px;">Informar Pagamento no portador {{ retornaPortadorEscolhido() }}:</h5>
      <b-form-group label="Data Pagamento:" class="list-group-quitacao">
        <b-form-input
          type="date"
          v-model="pagamento.DATA_PAGAMENTO"
          placeholder="Data Pagamento"
        ></b-form-input>
      </b-form-group>
      <InputValor 
        class="list-group-quitacao"
        v-model="pagamento.VALOR" 
        ref="valor" 
        label="Valor do Título" 
        :disabled="true"
      />
      <InputValor 
        v-if="valorPago"
        class="list-group-quitacao"
        v-model="pagamento.VALOR_PAGO" 
        ref="valorpago" 
        label="Valor já Pago" 
        :disabled="true"
      />
      <InputValor 
        class="list-group-quitacao"
        v-model="pagamento.VALOR_A_PAGAR" 
        ref="valorapagar" 
        label="Valor a ser Pago" 
        @change="ajustaTotalPago" 
      />
      <InputValor 
        v-if="valorPago" 
        class="list-group-quitacao"
        v-model="pagamento.TOTAL_PAGO" 
        ref="totalpago" 
        label="Total Pago" 
        :disabled="true"
      />
    </div>
    <div class="row" v-show="telas == 2">
      <h5 class="card-label" style="margin-bottom: 20px; margin-left: 2px;">Registra Pagamento no portador {{ retornaPortadorEscolhido() }}:</h5>
      <b-form-group label="Tipo da Movimentação:" class="list-group-quitacao">
        <b-form-radio 
          v-model="pagamento.TIPO_MOVIMENTO" 
          name="registra-pagamento" 
          v-for="tipoMovimentacaoOpcao in tipoMovimentacaoOpcoes" 
          :key="tipoMovimentacaoOpcao.value" 
          :value="tipoMovimentacaoOpcao.value" 
          style="display: inline-block; margin-right: 8px; width: 219px;"
          @change="trocaMovimento"
        >
          {{tipoMovimentacaoOpcao.text}}
        </b-form-radio>
      </b-form-group>
      <div class="row" style="width: 100%">
        <div class="col-md-3">
          <b-form-group label="Banco:" v-show="pagamento.TIPO_MOVIMENTO == 'C'">
            <b-form-input
              type="text"
              v-model="pagamento.BANCO"
              placeholder="Banco"
              maxlength="4"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Agência:" v-show="pagamento.TIPO_MOVIMENTO == 'C'">
            <b-form-input
              type="text"
              v-model="pagamento.AGENCIA"
              placeholder="Agência"
              maxlength="6"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Conta:" v-show="pagamento.TIPO_MOVIMENTO == 'C'">
            <b-form-input
              type="text"
              v-model="pagamento.CONTA"
              placeholder="Conta"
              maxlength="11"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group :label="(pagamento.TIPO_MOVIMENTO == 'C') ? 'Cheque:' : 'Número:'">
            <b-form-input
              type="text"
              v-model="pagamento.CHEQUE"
              :placeholder="(pagamento.TIPO_MOVIMENTO == 'C') ? 'Cheque' : 'Número'"
              v-mask="'##########'"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row" style="width: 100%">
        <div class="col-md-6">
          <b-form-group label="Histórico:">
            <b-form-input
              type="text"
              v-model="pagamento.HISTORICO"
              placeholder="Histórico"
              maxlength="60"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Bom Para:" v-show="pagamento.TIPO_MOVIMENTO == 'C'" class="list-group-quitacao">
            <b-form-input
              type="date"
              v-model="pagamento.DATA_BOMPARA"
              placeholder="Bom Para"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="">
            <b-form-checkbox
              v-model="pagamento.COMPENSADO"
              name="compensado"
              :value="true"
              :unchecked-value="false"
              style="margin-top: 2px;"
            >
              Já Compensado
            </b-form-checkbox>
            <b-form-checkbox
                v-model="pagamento.PROVISAO"
                name="provisao"
                :value="true"
                :unchecked-value="false"
                style="margin-top: 26px;"
              >
                Provisão
            </b-form-checkbox>
          </b-form-group>
        </div>
      </div>
      <div class="row" style="width: 100%">
        <div class="col-md-4">
          <b-form-group label="Documento:">
            <b-form-input
              type="text"
              v-model="pagamento.DOCUMENTO"
              placeholder="Documento"
              maxlength="15"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <InputValor 
            class="list-group-quitacao"
            v-model="pagamento.VALOR_A_PAGAR" 
            ref="valorapagarregistro" 
            label="Valor a ser Pago" 
            :disabled="true"
          />
        </div>
        <div class="col-md-4">
          <b-form-group label="Data Pagamento:" class="list-group-quitacao">
            <b-form-input
              type="date"
              v-model="pagamento.DATA_PAGAMENTO"
              placeholder="Data Pagamento"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="row" style="width: 100%;">
        <div class="col-md-6">
          <b-button 
            v-if="(telas == 1) || (telas == 2)"
            class="margin-btn-5 btn-block"
            @click="retrocederTela"
            variant="danger"
            :disabled="loading"
          >
            <i
              v-if="!loading"
              class="nav-icon flaticon2-left-arrow"
              style="font-size: 1rem;"
            ></i>
            <b-spinner
              v-if="loading"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
            Voltar
          </b-button>
        </div>
        <div class="col-md-6">
          <b-button 
            v-if="(telas == 1) || (telas == 2)"
            class="margin-btn-5 btn-block"
            @click="proximaTela"
            variant="primary"
            :disabled="loading"
          >
            {{ (telas == 1) ? "Continuar" : "Finalizar" }}
            <i
              v-if="(!loading) && (telas == 1)"
              class="nav-icon flaticon2-right-arrow"
              style="font-size: 1rem;"
            ></i>
            <b-spinner
              v-if="loading"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

import InputValor from "@/../../components-spirit/Inputs/InputValor.vue";

import Swal from "sweetalert2";

export default {
  name: "Rateio",
  data() {
    return {
      loading: false,
      telas: 0,
      portadores: [],
      pagamento: {
        ID_FLUXO_DE_CAIXA: "",
        ID_PORTADOR: "",
        DATA_PAGAMENTO: "",
        VALOR: "0",
        VALOR_PAGO: "0",
        VALOR_A_PAGAR: "0",
        TOTAL_PAGO: "0",
        TIPO_MOVIMENTO: "E",
        BANCO: "",
        AGENCIA: "",
        CONTA: "",
        CHEQUE: "",
        DATA_BOMPARA: "",
        COMPENSADO: true,
        PROVISAO: false,
        HISTORICO: "",
        DOCUMENTO: ""
      },
      tipoMovimentacaoOpcoes: [
        { text: "Espécie     ", value: "E" },
        { text: "Cheque", value: "C" },
        { text: "Cobrança", value: "L" },
        { text: "DOC/TED", value: "D" },
        { text: "Internet", value: "I" },
        { text: "Débito Automatico", value: "A" },
        { text: "Borderô (Ordem Pgto)", value: "B" },
        { text: "Crédito em Conta", value: "1" },
        { text: "Liquidação Eletrônica", value: "2" },
        { text: "Pgto Salario em CC (Holerite)", value: "3" },
        { text: "Concess/Tributos c/ Cd.Barras", value: "4" },
        { text: "Tributos sem Cd.Barras/FGTS", value: "5" },
        { text: "PIX", value: "P" }
      ]
    }
  },
  components: {
    InputValor
  },
  props: ["idFluxoDeCaixa", "idPortador", "valor", "valorPago"],
  computed: {
    ...mapGetters(["fgModoPR"]),
  },
  async mounted() {
  },
  methods: {
    ...mapActions([
      "getPortadores",
      "updateFluxoDeCaixaPagamento"
    ]),
    hiddenModal() {
      this.telas = 0;
      this.$emit('saiuModal');

      this.pagamento.ID_FLUXO_DE_CAIXA = "";
      this.pagamento.ID_PORTADOR = "";
      this.pagamento.DATA_PAGAMENTO = "";
      this.pagamento.VALOR = "0";
      this.pagamento.VALOR_PAGO = "0";
      this.pagamento.VALOR_A_PAGAR = "0";
      this.pagamento.TOTAL_PAGO = "0";
      this.pagamento.TIPO_MOVIMENTO = "E";
      this.pagamento.BANCO = "";
      this.pagamento.AGENCIA = "";
      this.pagamento.CONTA = "";
      this.pagamento.CHEQUE = "";
      this.pagamento.DATA_BOMPARA = "";
      this.pagamento.COMPENSADO = true;
      this.pagamento.PROVISAO = false;
      this.pagamento.HISTORICO = "";
      this.pagamento.DOCUMENTO = "";
    },
    fechar() {
      this.$refs["modal-quitacao"].hide();
    },
    async show() {
      this.$refs["modal-quitacao"].show();

      if(this.idFluxoDeCaixa) {
        this.pagamento.ID_FLUXO_DE_CAIXA = this.idFluxoDeCaixa;
        this.loading = true;
        this.portadores = await this.getPortadores();
        this.loading = false;
      
        this.pagamento.DATA_PAGAMENTO = moment().format("YYYY-MM-DD");
        this.pagamento.VALOR = parseFloat(this.valor).toFixed(2);

        if(this.valorPago) {
          this.pagamento.VALOR_A_PAGAR = parseFloat(this.valor) -  parseFloat(this.valorPago);
          if(this.pagamento.VALOR_A_PAGAR < 0) {
            this.pagamento.VALOR_A_PAGAR = 0;
          }
          this.pagamento.VALOR_PAGO = parseFloat(this.valorPago).toFixed(2);
        } else {
          this.pagamento.VALOR_A_PAGAR = parseFloat(this.valor);
        }
        this.pagamento.VALOR_A_PAGAR = this.pagamento.VALOR_A_PAGAR.toFixed(2);

        this.pagamento.TOTAL_PAGO = parseFloat(this.valor).toFixed(2);
      }
    },
    selecionarPortador(idPortador) {
      this.pagamento.ID_PORTADOR = idPortador;
      this.telas = 1;
    },
    ajustaTotalPago() {
      this.pagamento.TOTAL_PAGO = (parseFloat(this.pagamento.VALOR_PAGO) + parseFloat(this.pagamento.VALOR_A_PAGAR)).toFixed(2);
    },
    retrocederTela() {
      this.telas -= 1;
    },
    proximaTela() {
      if(this.telas < 2) {
        this.telas += 1;
      } else {
        this.salvar();
      }
    },
    retornaPortadorEscolhido() {
      let retorno = "";
      this.portadores.forEach((item) => {
        if(item.ID_PORTADOR == this.pagamento.ID_PORTADOR) {
          retorno = item.NOME
        }
      });
      return retorno;
    },
    trocaMovimento() {
      let letras = ["E", "L", "D", "I", "A", "P"];

      let retorno = false;

      letras.forEach((item) => {
        if(item == this.pagamento.TIPO_MOVIMENTO) {
          retorno = true;
        }
      });

      this.pagamento.COMPENSADO = retorno;
    },
    async salvar() {
      this.loading = true;
      await this.updateFluxoDeCaixaPagamento(this.pagamento);
      this.loading = false;
      
      Swal.fire({
        title: "Sucesso",
        text: "O pagamento foi efetuado com sucesso.",
        icon: "success",
        timer: 3000,
        showConfirmButton: false
      });
      
      this.fechar();

      this.$emit('salvar')
    }
  }
}
</script>

<style lang="scss">
  .list-group-quitacao {
    width: 100%;
  }

  .list-group-item-quitacao {
    cursor: pointer;
  }

  .list-group-item-quitacao:hover {
    background-color: #e5e5e5;
  }

  .list-group-item-quitacao-selecionado {
    background-color: #e5e5e5;
  }
</style>